import React from 'react';
import { Link } from 'react-router-dom';
import './FSSC22000Certificate.css';

const FSSC22000Certificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Product Certification</div>
            <h1 className="page-title">FSSC 22000 Certificate</h1>
            <div className="page-text-content">
              <p>
                Dear Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we offer FSSC 22000 Certification service 
                to businesses, emphasizing food safety, quality, and approval.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is FSSC 22000?</h2>
            <div className="page-text-content">
              <p>
                FSSC 22000 is an internationally recognized certification for businesses complying with 
                Food Safety Management System standards. This certification promotes safe and high-quality 
                production in the food industry, ensuring that products meet the highest safety and 
                quality requirements.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Obtain FSSC 22000 Certification?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Food Safety and Quality</h3>
                <p className="reason-description">
                  FSSC 22000 ensures adherence to high safety and quality standards, demonstrating your 
                  commitment to food safety.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. International Validity</h3>
                <p className="reason-description">
                  FSSC 22000 makes your products more competitive in international markets and provides 
                  reliability to your customers.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Legal Compliance</h3>
                <p className="reason-description">
                  FSSC 22000 helps you comply with food safety regulations and minimizes legal risks.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Consumer Confidence</h3>
                <p className="reason-description">
                  FSSC 22000 provides assurance of product reliability and enhances your brand 
                  reputation among consumers.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain FSSC 22000 Certification?</h2>
            <div className="page-text-content">
              <p>
                To obtain FSSC 22000 Certification, businesses need to establish and implement food 
                safety management systems that comply with the standard's requirements. NQC (Nova Quality 
                Certification Agency) guides you through this process, from initial assessment to final 
                certification, ensuring a smooth and successful certification journey.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is a reliable partner for businesses seeking 
                FSSC 22000 Certification. Our experienced and expert team helps you fulfill your food 
                safety commitments and enhance your business sustainability.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Conclusion</h2>
            <div className="page-text-content">
              <p>
                FSSC 22000 Certification is of great importance for reinforcing your leadership in the 
                food sector and building consumer trust. As NQC (Nova Quality Certification Agency), we 
                are pleased to support you in obtaining this prestigious certification. Feel free to 
                contact us for more information or to ask any questions.
              </p>
              <p>
                Best regards,
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default FSSC22000Certificate;

